import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import Vuetify from 'vuetify'
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import 'babel-polyfill'
import './plugins/vuetify'

// ant
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import enLocale from './lang/en';
// import zhLocale from './lang/zh';
import './scss/index.scss' // global css

import App from './App.vue'
import router from './router'
import store from './store'
import 'animate.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(VueQuillEditor /* { default global options } */ )

Vue.use(VueAxios, axios)

Vue.use(Vuetify)

Vue.config.productionTip = false
Vue.use(VueI18n)

Vue.use(Antd);
Vue.use(ElementUI);

const messages = {
  // en: {
  //   ...enLocale
  // },
  // zh: {
  //   ...zhLocale
  // }
}
const i18n = new VueI18n({
  messages, // set locale messages
  locale: Cookies.get('language') || 'zh' // set locale 預設語言
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')